'use client';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import Container from '@/components/@base/container';

import IntroCard from '../introCard';
import MedalsCard from '../medalsCard';
import { storeListQueryOptions } from '../../services/hooks';

export default function Intro() {
  const { store }: { store: string } = useParams();

  const { data: response } = useSuspenseQuery(storeListQueryOptions(store, 1));
  const { payload: storeData, headers } = response;
  return (
    <Container className='grid grid-cols-1 gap-7 lg:grid-cols-[3fr_1.2fr]'>
      {storeData && (
        <>
          <IntroCard
            name={storeData.name}
            description={storeData.description}
            logo={storeData.logo}
            product={
              storeData.products && storeData.products?.length !== 0
                ? storeData.products[0]
                : undefined
            }
          />
          <MedalsCard
            medals={storeData.medals}
            createdAt={storeData.createdAt}
            totalProducts={headers['x-pagination-total-count']}
          />
        </>
      )}
    </Container>
  );
}
